// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"83904489","845":"2210818c"}[chunkId] + ".chunk.js";
};